var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "actions" },
      [
        !_vm.isCancellationPossible
          ? [
              _c(
                "button",
                {
                  staticClass: "btn bg-purple",
                  on: {
                    click: function($event) {
                      _vm.setCancellationAction("cancel")
                    }
                  }
                },
                [_c("span", [_vm._v("Cancelar agendamento")])]
              )
            ]
          : [
              !_vm.isCancellation
                ? _c(
                    "button",
                    {
                      staticClass: "btn bg-purple",
                      on: {
                        click: function($event) {
                          _vm.setCancellationAction("inform-absence")
                        }
                      }
                    },
                    [_c("span", [_vm._v("Informar falta do profissional")])]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isCancellation
                ? _c(
                    "button",
                    {
                      staticClass: "btn bg-purple",
                      on: {
                        click: function($event) {
                          _vm.setCancellationAction("reschedule")
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v("Reagendar (inclusive para o mesmo dia)")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn bg-purple",
                  on: {
                    click: function($event) {
                      _vm.setCancellationAction("credit")
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      "Cancelar e deixar como crédito para ser reagendada no futuro"
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn bg-purple",
                  on: {
                    click: function($event) {
                      _vm.setCancellationAction("cancel")
                    }
                  }
                },
                [_c("span", [_vm._v("Cancelar e solicitar o reembolso")])]
              )
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert" }, [
      _c("p", [_vm._v("O que você deseja fazer com o seu pedido?")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7603ebef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7603ebef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Components/Actions/Cancellation/CancellationType.vue
// module id = null
// module chunks = 